import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ModalService } from '@ibe/services/ui';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { TimeoutSvcService } from '@ibe.services/timeout-svc.service';
import { Router } from '@angular/router';
import { SidebarService } from '@ibe.components/common/sidebar/sidebar.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { INDRAApiService } from '@ibe/services';
import * as ModalActions from '../../../store/actions/modal.actions';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';

@Component({
	selector: 'app-expirate-alert',
	templateUrl: './expirate-alert.indra.component.html',
	styleUrls: ['./expirate-alert.component.scss']
})
export class INDRAExpirateAlertComponent extends AbstractModalContentComponent {

	isLoading: boolean = false;

	constructor(
		protected modalService: ModalService,
		private timeoutSvc: TimeoutSvcService,
		private changeRef: ChangeDetectorRef,
		private router: Router,
		private sidebarService: SidebarService,
		private storageService: INDRAStorageService,
		private apiService: INDRAApiService,
		private store: Store<fromStore.State>,

	) {
		super(modalService);
		this.TYPE = 'dialog';
	}
	
	config = {
		template: '$!m!:$!s!',
		leftTime: this.timeoutSvc.INDRA_getSessionTimeoutTimeRemainingInSeconds() || 60
	}

	closeModal() {
		this.store.dispatch(new ModalActions.ResetAction());
		this.modalService.close();
	}

	INDRA_sessionAccept() {
		this.isLoading = true;
		this.timeoutSvc.sessionRenew().subscribe(res => {
			if (res) {
				this.timeoutSvc.renewLimitReached = res.renewLimitReached; 
				this.isLoading = false;
				this.timeoutSvc.resetTimer();
				this.changeRef.markForCheck();
				this.closeModal();
			}
		},error => {
			this.isLoading = false;
			this.timeoutSvc.resetTimer();
			this.changeRef.markForCheck();
			this.closeModal();
		})
		
	}

	async INDRA_sessionCancel() {
		this.storageService.set('allow_navigate', 'true'); // allow redirection to search page with out confirm modal
		
		// clear/reset backend session
		try { const sessionDeletePromise = await this.timeoutSvc.sessionDelete().toPromise(); } catch (err) { console.error(err); }
		
		this.timeoutSvc.resetTimer();
		
		// close amadeus session
		try { const signOutPromise = await this.apiService.INDRA_signOutFromSession().toPromise();  } catch (err) { console.error(err); }
		
		this.changeRef.markForCheck();
		this.sidebarService.closeSidebar();
		this.closeModal();

		if (this.router.url !== '/booking') {
			setTimeout(() => {
				this.router.navigate(['/booking']);
			}, 500);
		}
	}

	INDRA_handleCountdownFinish() {
		this.INDRA_sessionCancel();
	}
}
